var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-6"},[_c('AnswerForm',{attrs:{"is-edit":true}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }